module.exports = __webpack_public_path__ + "img/IMG-20200309-WA0020.eefc700b.jpg";